import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	resetCommonCfgDetails,
	commonCfgDetailsReqList
} from "../../redux/actions/commonCfgDetailsAction";

import {
	resetupdateCommonCfgDetails,
	updateCfgDetailsReqList
} from "../../redux/actions/getUpdateComDetailsAction";
import FileBase64 from "../../components/Upload/UploadFile";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import Layout from "../../components/Wrappers/Layout";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { Row, Col, Card, Alert } from "reactstrap";
import BackButton from "../../components/BackButton/BackButton";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const CommonConfiguration = () => {
	const [isFraudCheckAllowed, setIsFraudCheckAllowed] = useState("");
	const [kycDocVer, setkycDocVer] = useState("");
	const [kybDocChkType, setkybDocChkType] = useState("");
	const [isEMAILAllowed, setIsEmailAllowed] = useState("");

	const [individualAddRequired, setIndividualAddRequired] = useState("");
	const [notificationPassword, setNotificationPassword] = useState("");
	const [packageName, setPackageName] = useState("");
	const [supportEmail, setSupportEmail] = useState("");
	const [supportFAQURL, setSupportFAQURL] = useState("");
	const [uploadCertificate, setuploadCertificate] = useState("T");
	const [supportMobile, setsupportMobile] = useState("");
	const [getUpdateComDetailStatus, setgetUpdateComDetailStatus] =
		useState(false);
	const [getUpdateComDetailRes, setgetUpdateComDetailRes] = useState("");
	const [isSmsOtp, setIsSmsOtp] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [kycCheck, setkycCheck] = useState('');
	const [kycIdCheck, setkycIdCheck] = useState('');
	const [selfieCheck, setselfieCheck] = useState('');

	const [currConversion, setCurrConversion] = useState('')

	const [securityQuestion, setSecurityQuestion] = useState('')
	const [markupconversion ,setmarkupConversion] =useState('')
	const [refundmarkupconversion ,setRefundmarkupconversion ]= useState('')

	//Two Factor Authentucation

	const [twofaSmsOtpAllowed, settwofaSmsOtpAllowed] = useState('');
	const [twofaEmailOtpAllowed, settwofaEmailOtpAllowed] = useState('');
	const [twofaConfigurationUser, settwofaConfigurationUser] = useState('');

	const [uploadPhoto, setUploadPhoto] = useState("");
	const [uploadPhotoName, setUploadPhotoName] = useState("");
	// const handleAttachmentsDoc = (e, nidFronts) => {

	// 	if (nidFronts == "uploadPhoto") {
	// 		setUploadPhoto(e.base64);
	// 		setUploadPhotoName(e.name);
	// 	}

	// };
	const handleAttachmentsDoc = (e, nidFronts) => {
		const acceptedTypes = [
			"application/msword",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		];

		if (!e || !acceptedTypes.includes(e.type)) {
			alert("Only Word documents (.doc, .docx) are allowed.");
			return;
		}

		if (nidFronts === "uploadPhoto") {
			setUploadPhoto(e.base64);
			setUploadPhotoName(e.name);
		}
	};



	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const commonCfgDetailsListRes = useSelector(
		({ commonCfgDetailsList }) => commonCfgDetailsList
	);

	const getUpdateComDetailsRes = useSelector(
		({ getUpdateComDetails }) => getUpdateComDetails
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	// console.log("getUpdateComDetailsRes", getUpdateComDetailsRes);
	// console.log("getUpdateComDetailsRes", getUpdateComDetailsRes);

	useEffect(() => {
		if (getUpdateComDetailStatus) {
			if (getUpdateComDetailsRes.data.status == "success") {
				setgetUpdateComDetailRes(getUpdateComDetailsRes.data);
				setNotificationOpen(true);
				getComoncfgReqsListApi();
			}
			if (getUpdateComDetailsRes.data.status == "Failed") {
				setgetUpdateComDetailRes(getUpdateComDetailsRes.data);
				setNotificationOpen(true);
				if (
					getUpdateComDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUpdateComDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getUpdateComDetailsRes.data.status == "failed") {
				setgetUpdateComDetailRes(getUpdateComDetailsRes.data);
				setNotificationOpen(true);
				if (
					getUpdateComDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getUpdateComDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [getUpdateComDetailsRes.data.status]);

	useEffect(() => {
		if (commonCfgDetailsListRes.data.status == "success") {
			setIsFraudCheckAllowed(
				commonCfgDetailsListRes.data.commonConfList.isFraudCheckAllowed
			);
			setkycDocVer(commonCfgDetailsListRes.data.commonConfList.kycDocVer);
			setkybDocChkType(
				commonCfgDetailsListRes.data.commonConfList.kybDocChkType
			);
			setkycCheck(commonCfgDetailsListRes.data.commonConfList.kycCheck);
			setkycIdCheck(commonCfgDetailsListRes.data.commonConfList.kycIdCheck);
			setselfieCheck(commonCfgDetailsListRes.data.commonConfList.selfie);
			setIndividualAddRequired(
				commonCfgDetailsListRes.data.commonConfList.individualAddRequired
			);
			setNotificationPassword(
				commonCfgDetailsListRes.data.commonConfList.notificationPassword
			);
			setPackageName(commonCfgDetailsListRes.data.commonConfList.packageName);
			setSupportEmail(commonCfgDetailsListRes.data.commonConfList.supportEmail);
			setSupportFAQURL(
				commonCfgDetailsListRes.data.commonConfList.supportFAQURL
			);
			setIsEmailAllowed(commonCfgDetailsListRes.data.commonConfList.emailOTP);
			setIsSmsOtp(commonCfgDetailsListRes.data.commonConfList.smsOTP);
			setsupportMobile(
				commonCfgDetailsListRes.data.commonConfList.supportMobile
			);
			settwofaSmsOtpAllowed(commonCfgDetailsListRes.data.commonConfList.twoFaSmsOtpAllowed);
			settwofaEmailOtpAllowed(commonCfgDetailsListRes.data.commonConfList.twoFaEmailOtpAllowed);
			settwofaConfigurationUser(commonCfgDetailsListRes.data.commonConfList.twoFaConfigurationUser);
			setCurrConversion(commonCfgDetailsListRes.data.commonConfList.currencyConversion);
			setSecurityQuestion(commonCfgDetailsListRes.data.commonConfList.securityFlag);
			setmarkupConversion(commonCfgDetailsListRes.data.commonConfList.isMarkupConversionRequired);
             setRefundmarkupconversion(commonCfgDetailsListRes.data.commonConfList.isRefundMarkupConversionRequired);

		}
	}, [commonCfgDetailsListRes.data.status]);

	var authToken = regenerateTokenRes.data.AuthToken;

	const dispatch = useDispatch();

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getComoncfgReqsListApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getComoncfgReqsListApi = () => {
		const getComoncfgReqs = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			}
		};
		return dispatch(commonCfgDetailsReqList(getComoncfgReqs, authToken));
	};

	const updateComnConfigurationListApi = () => {
		setgetUpdateComDetailStatus(true);
		const updateComnConfigurationListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			settingsRequestVO: {
				emailOTP: isEMAILAllowed === '1' ? 'Y' : 'N',
				smsOTP: isSmsOtp === '1' ? 'Y' : 'N',
				individualAddRequired: individualAddRequired === '1' ? 'Y' : 'N',
				certiType: uploadCertificate,
				certificateFileName: uploadPhoto.split(",")[1] || "-",
				notificationPassword: notificationPassword,
				packageName: packageName,
				supportEmail: supportEmail,
				supportMobile: supportMobile,
				supportFAQURL: supportFAQURL,
				isFraudCheckAllowed: isFraudCheckAllowed,
				docChkType: kycDocVer,
				kybDocChkType: kybDocChkType,
				kycCheck: kycCheck,
				kycIdCheck: kycIdCheck,
				selfie: selfieCheck,
				// twofaSmsOtpAllowed: twofaSmsOtpAllowed,
				// twofaEmailOtpAllowed: twofaEmailOtpAllowed,
				// twofaConfigurationUser: twofaConfigurationUser,
				currencyConversion: currConversion,
				isMarkupConversionRequired:markupconversion,
				isRefundMarkupConversionRequired:refundmarkupconversion,
				securityFlag: securityQuestion
			}
		};

		return dispatch(updateCfgDetailsReqList(updateComnConfigurationListReq, regenerateTokenRes.data.AuthToken));
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "isFraudCheckAllowed") {
			setIsFraudCheckAllowed(value);
		}
		if (name === "kycDocVer") {
			setkycDocVer(value);
		}

		if (name === "kybDocChkType") {
			setkybDocChkType(value);
		}

		if (name === "individualAddRequired") {
			setIndividualAddRequired(value);
		}

		if (name === "notificationPassword") {
			setNotificationPassword(value);
		}

		if (name === "packageName") {
			setPackageName(value);
		}

		if (name === "supportEmail") {
			setSupportEmail(value);
		}

		if (name === "supportFAQURL") {
			setSupportFAQURL(value);
		}

		if (name === "isEMAILAllowed") {
			setIsEmailAllowed(value);
		}

		if (name === "isSmsOtp") {
			setIsSmsOtp(value);
		}

		if (name === "notificationPassword") {
			setNotificationPassword(value);
		}

		if (name === "packageName") {
			setPackageName(value);
		}

		if (name === "supportEmail") {
			setSupportEmail(value);
		}

		if (name === "supportMobile") {
			setsupportMobile(value);
		}
		if (name === "uploadCertificate") {
			setuploadCertificate(value);
		}
		if (name === 'kycCheck') {
			setkycCheck(value);
		}
		if (name === 'kycIdCheck') {
			setkycIdCheck(value);
		}
		if (name === 'selfieCheck') {
			setselfieCheck(value);
		}
		//2fa configuration
		if (name === 'twofaSmsOtpAllowed') {
			settwofaSmsOtpAllowed(value);
		}
		if (name === 'twofaEmailOtpAllowed') {
			settwofaEmailOtpAllowed(value);
		}
		if (name === 'twofaConfigurationUser') {
			settwofaConfigurationUser(value);
		}
		if (name === 'currConversion') {
			setCurrConversion(value);
		}
		if (name === 'securityQuestion') {
			setSecurityQuestion(value);
		}
		if(name==='markupconversion'){
			setmarkupConversion(value);
		}
		if(name==="refundmarkupconversion"){
			setRefundmarkupconversion(value);
		}
	};

	return (
		<>
			<Layout>
				<BackButton />
				{/* <BackButton /> */}
				<Card>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1"> Fraud </Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Fraud Check Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="isFraudCheckAllowed"
								value={isFraudCheckAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="KYC Document Verification"
								fullWidth
								variant="standard"
								type="text"
								name="kycDocVer"
								value={kycDocVer}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Auto">Auto</MenuItem>
								<MenuItem value="Manual">Manual</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="KYB Document Verification"
								fullWidth
								variant="standard"
								type="text"
								name="kybDocChkType"
								value={kybDocChkType}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Auto">Auto</MenuItem>
								<MenuItem value="Manual">Manual</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="KYC Check"
								fullWidth
								variant="standard"
								type="text"
								name="kycCheck"
								value={kycCheck || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Auto">Auto</MenuItem>
								<MenuItem value="Manual">Manual</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="KYC ID Check"
								fullWidth
								variant="standard"
								type="text"
								name="kycIdCheck"
								value={kycIdCheck || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Auto">Auto</MenuItem>
								<MenuItem value="Manual">Manual</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Selfie Check"
								fullWidth
								variant="standard"
								type="text"
								name="selfieCheck"
								value={selfieCheck || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Auto">Auto</MenuItem>
								<MenuItem value="Manual">Manual</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1"> Signup </Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Email OTP during Signup Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="isEMAILAllowed"
								value={isEMAILAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="SMS OTP during Signup Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="isSmsOtp"
								value={isSmsOtp || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="
                Individual Address Required"
								fullWidth
								variant="standard"
								type="text"
								name="individualAddRequired"
								value={individualAddRequired}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Security Question"
								fullWidth
								variant="standard"
								type="text"
								name="securityQuestion"
								value={securityQuestion || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					{/* <Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center themeBackground"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1">
									{" "}
									Two Factor Authentication{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								label="SMS OTP During Login Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="twofaSmsOtpAllowed"
								value={twofaSmsOtpAllowed || ""}
								onChange={handleChange}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								label="Email OTP During Login Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="twofaEmailOtpAllowed"
								value={twofaEmailOtpAllowed || ""}
								onChange={handleChange}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								label="2FA Configuration By User"
								fullWidth
								variant="standard"
								type="text"
								name="twofaConfigurationUser"
								value={twofaConfigurationUser || ""}
								onChange={handleChange}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
					</Grid> */}

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1">
									{" "}
									Push Notification(Common for all roles){" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4} style={{ margin: "auto" }}>
							{/* <FileBase64
								multiple={false}
								name={false}
								id="documentGuard"
								accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
								//onDone={(e) => handleAttachmentsDoc(e, "nidFronts")}
								//showUploadList={false}
								//value={nidFrontsName}
								disabled
							/> */}
							{/* <FileBase64
								multiple={false}
								name={false}
								id="documentGuard2"
								// accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
								accept=".doc, .docx"
								// accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
								onDone={(e) => handleAttachmentsDoc(e, "uploadPhoto")}
								showUploadList={false}
								value={uploadPhotoName}
								
							/> */}
							<FileBase64
								multiple={false}
								name={false}
								id="documentGuard2"
								accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
								onDone={(e) => handleAttachmentsDoc(e, "uploadPhoto")}
								showUploadList={false}
								value={uploadPhotoName}
							/>
							  {uploadPhotoName && <p>Uploaded File: {uploadPhotoName}</p>}
							{/* {uploadPhotoName ? uploadPhotoName : ""} */}
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Upload Certificate"
								fullWidth
								variant="standard"
								type="text"
								name="uploadCertificate"
								value={uploadCertificate || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="T">Test</MenuItem>
								<MenuItem value="L">Live</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								// autoFocus
								margin="dense"
								label="Notification Password"
								fullWidth
								variant="standard"
								type="text"
								name="notificationPassword"
								value={notificationPassword}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								// autoFocus
								margin="dense"
								id="name"
								label="
                Package Name"
								fullWidth
								variant="standard"
								type="text"
								name="packageName"
								onChange={handleChange}
								value={packageName}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								// autoFocus
								margin="dense"
								label="Email"
								fullWidth
								variant="standard"
								type="text"
								name="supportEmail"
								value={supportEmail}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								// autoFocus
								margin="dense"
								id="name"
								label="
                Mobile No"
								fullWidth
								variant="standard"
								type="text"
								name="supportMobile"
								value={supportMobile}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								// autoFocus
								margin="dense"
								id="name"
								label="
                Support URL"
								fullWidth
								variant="standard"
								type="text"
								name="supportFAQURL"
								value={supportFAQURL}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1">
									{" "}
									Currency{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Currency Conversion"
								fullWidth
								variant="standard"
								type="text"
								name="currConversion"
								value={currConversion}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Auto">Auto</MenuItem>

								<MenuItem value="Manual">Manual</MenuItem>


							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Markup Conversion"
								fullWidth
								variant="standard"
								type="text"
								name="markupconversion"
								value={markupconversion || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label=" Refund Markup Conversion"
								fullWidth
								variant="standard"
								type="text"
								name="refundmarkupconversion"
								value={refundmarkupconversion || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

					</Grid>

					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						style={{ marginLeft: "auto", marginRight: "auto" }}
					>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={updateComnConfigurationListApi}
						>
							Save
						</CustomButton>
					</Grid>
				</Card>
			</Layout>

			{getUpdateComDetailRes.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getUpdateComDetailRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{getUpdateComDetailRes.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{getUpdateComDetailRes.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default CommonConfiguration;
